export const PP_COL_W = {
    actions: 50,
    id: 60,

    // fee table
    feeName: 220,
    feeUnitType: 100,
    feeOfferingType: 60,

    date: 140,
    units: 60,
    age: 80,
    price: 80,
    applicable: 100,
    delete: 72,

    // product table
    productName: 320,
    schools: 180,
    bandStrategy: 110,
    weeks: 60,
    weeksTo: 140,
    dateStrategy: 140,
} as const;
